import { useState } from "react";
import { useSettings } from "../hooks/useSettings";

const SecuritySettings = () => {
    const { updatePassword, loading } = useSettings();
    const [passwords, setPasswords] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    const handleChange = (e) => {
        setPasswords((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updatePassword(passwords);
    };

    return (
        <div className="tab-content">
            <h2>
                Security Details
            </h2>

            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>
                        Current Password
                    </label>

                    <input 
                        type="password" 
                        name="currentPassword" 
                        onChange={handleChange} 
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>
                        New Password
                    </label>

                    <input 
                        type="password" 
                        name="newPassword" 
                        onChange={handleChange} 
                        required 
                    />
                </div>

                <div className="form-group">
                    <label>
                        Confirm New Password
                    </label>

                    <input 
                        type="password" 
                        name="confirmPassword" 
                        onChange={handleChange} 
                        required 
                    />
                </div>
                
                <button type="submit" disabled={loading}>
                    {loading ? "Updating..." : "Change Password"}
                </button>
            </form>
        </div>
    );
};
export default SecuritySettings;